export const MESSAGE_SAVE_SUCCESS = 'ギャラリーに保存しました！';
export const MESSAGE_SAVE_FAIL = '保存できませんでした...';
